import React from 'react';

import DebugOutput from '~/src/components/debug/output/DebugOutput';
import Boomerang from '~/src/components/svg/general/Boomerang';

import {classNames} from '~/src/utilities/helpers/css';
import {TeaserFormat} from '~/src/utilities/constants/formats';

import css from './DebugSection.module.scss';

class DebugSection extends React.Component {
    render() {
        const classes = classNames(css, 'section', {isCategorySection: true});
        const teaserClasses = classNames(css, 'teaser', TeaserFormat.TEASER_LARGE);

        return (
            <section className={classes} data-testid="Section">
                <div className={css.main}>
                    <div className={css.header}>
                        <h1 className={css.title}>
                            Error : {this.props.title}
                            <Boomerang />
                        </h1>
                    </div>
                    <div className={css.teasers}>
                        <div className={teaserClasses}>
                            <div className={css.debug}>
                                <div className={css.banner}></div>
                                <DebugOutput message={`Feed:\n${JSON.stringify(this.props, null, 2)}`} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default DebugSection;
